import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heading: {
    id: 'course-authoring.pages-resources.heading',
    defaultMessage: 'Pages & Resources',
  },
  settings: {
    id: 'course-authoring.pages-resources.resources.settings.button',
    defaultMessage: 'settings',
  },
  viewLiveButton: {
    id: 'course-authoring.pages-resources.viewLive.button',
    defaultMessage: 'View live',
  },
  enabled: {
    id: 'course-authoring.badge.enabled',
    defaultMessage: 'Enabled',
  },
});

export default messages;
